import { render, staticRenderFns } from "./BackgroundLayer.vue?vue&type=template&id=57c49c2b&"
import script from "./BackgroundLayer.vue?vue&type=script&lang=js&"
export * from "./BackgroundLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports